module.exports = __webpack_public_path__ + "static/media/GrinningFace.0c41ee68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SVG/GrinningFace.svg
// module id = 1176
// module chunks = 0